import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output, } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSize, SwitchModule } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'qpoint-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QPointSwitchComponent),
            multi: true,
        }
    ],
    imports: [
        SwitchModule
    ]
})
export class QPointSwitchComponent implements ControlValueAccessor {
  @Input() readonly: boolean;
  @Input() size: InputSize = 'small';
  @Input() disabled: boolean;
  @Input() checked: boolean;

  @Output() blur = new EventEmitter();
  @Output() focus = new EventEmitter();
  @Output() valueChange = new EventEmitter<boolean>();

  constructor(private cdr: ChangeDetectorRef) {
  }

  onChange = (_: any) => {
  }
  onTouched = () => {
  }

  writeValue(value: boolean) {
    this.checked = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  onBlur() {
    this.blur.emit();
  }

  onFocus() {
    this.focus.emit();
  }

  valueChanged(event: boolean) {
    this.writeValue(event);
    this.valueChange.emit(event);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
